<template>
  <div class="Material_management">
    <el-form :inline="true" style="margin-left:20px;padding-top:20px" class="demo-form-inline">
      <!-- <el-form-item label="上级栏目" prop="PItemKey">
        <el-cascader ref="wcascader" v-model="fItemKey" @change="Selected_to_shut_dow" @expand-change="bumen" :options="data" :props="{ checkStrictly: true }" clearable placeholder="请选择上级栏目"></el-cascader>
      </el-form-item> -->
      <el-form-item label="素材标题">
        <el-input v-model="MaterialName" placeholder="请输入素材标题查询"></el-input>
      </el-form-item>

      <el-form-item label="内容形式">
        <el-select v-model="MaterialType" placeholder="请选择内容形式">
          <el-option label="图片" value="2"></el-option>
          <el-option label="视频" value="3"></el-option>
          <el-option label="音频" value="4"></el-option>
          <el-option label="文章" value="1"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="onSubmit">查询</el-button>
        <el-button type="primary" @click="resetfun()">重置</el-button>
        <el-button type="primary" @click="delfuns()">批量删除</el-button>
      </el-form-item>

    </el-form>

    <div style="width: 300px;float: left;height: calc(100% - 100px);margin-left: 10px;">
      <el-tree :data="data" class="flow-tree" node-key="value" check-strictly :expand-on-click-node="false" @node-click="check_tree" @node-expand="check_tree" ref="treeForm"></el-tree>
    </div>

    <div style="overflow:auto;width: calc(100% - 320px);float: right;height: calc(100% - 100px);position: relative;">
      <ul class="tp" style="height: 800px;">
        <li v-for="(item, i) in list" :key="i">
          <!-- 1=文章-->
          <div  v-if="item.materialType == '1'">
            <div class="tp_top">{{ item.materialName }}</div>
            <img @click="gourl(1, item.materialKey)" :src="item.materialCover" alt="">
            <div class="tp_bou" @click="delfun(item.materialKey)">删除</div>
            <el-checkbox-group style="margin-left: 10px;" v-model="checkedCities" @change="handleCheckedCitiesChange">
              <el-checkbox :label="item.materialKey"><br /></el-checkbox>
            </el-checkbox-group>
          </div>

          <!-- 2=图片 -->
          <div v-if="item.materialType == '2'">
            <div class="tp_top">{{ item.materialName }}</div>
            <img @click="gourl(2, item.materialKey)" :src="item.materialPath" alt="">
            <div class="tp_bou" @click="delfun(item.materialKey)">删除</div>
            <el-checkbox-group style="margin-left: 10px;" v-model="checkedCities" @change="handleCheckedCitiesChange">
              <el-checkbox :label="item.materialKey"><br /></el-checkbox>
            </el-checkbox-group>
          </div>

          <!-- 3=音乐 -->
          <div v-if="item.materialType == '3'">
            <div class="tp_top">{{ item.materialName }}</div>
            <img @click="gourl(3, item.materialKey)" :src="item.materialCover" alt="">
            <div class="tp_bou" @click="delfun(item.materialKey)">删除</div>
            <el-checkbox-group style="margin-left: 10px;" v-model="checkedCities" @change="handleCheckedCitiesChange">
              <el-checkbox :label="item.materialKey"><br /></el-checkbox>
            </el-checkbox-group>
          </div>

          <!-- 4=视频 -->
          <div v-if="item.materialType == '4'">
            <div class="tp_top">{{ item.materialName }}</div>
            <img @click="gourl(4, item.materialKey)" :src="item.materialCover" alt="">
            <div class="tp_bou" @click="delfun(item.materialKey)">删除</div>
            <el-checkbox-group style="margin-left: 10px;" v-model="checkedCities" @change="handleCheckedCitiesChange">
              <el-checkbox :label="item.materialKey"><br /></el-checkbox>
            </el-checkbox-group>
          </div>

          <!-- 51word文档 -->
          <div v-if="item.materialType == '51'">
            <div class="tp_top">{{ item.materialName }}</div>
            <img @click="gourl(5, item.materialKey)" :src="item.materialCover" alt="">
            <div class="tp_bou" @click="delfun(item.materialKey)">删除</div>
            <el-checkbox-group style="margin-left: 10px;" v-model="checkedCities" @change="handleCheckedCitiesChange">
              <el-checkbox :label="item.materialKey"><br /></el-checkbox>
            </el-checkbox-group>
          </div>

          <!-- 52pdf档 -->
          <div v-if="item.materialType == '52'">
            <div class="tp_top">{{ item.materialName }}</div>
            <img @click="gourl(6, item.materialKey)" :src="item.materialCover" alt="">
            <div class="tp_bou" @click="delfun(item.materialKey)">删除</div>
            <el-checkbox-group style="margin-left: 10px;" v-model="checkedCities" @change="handleCheckedCitiesChange">
              <el-checkbox :label="item.materialKey"><br /></el-checkbox>
            </el-checkbox-group>
          </div>

          <!-- 53excel文档 -->
          <div v-if="item.materialType == '53'">
            <div class="tp_top">{{ item.materialName }}</div>
            <img @click="gourl(7, item.materialKey)" :src="item.materialCover" alt="">
            <div class="tp_bou" @click="delfun(item.materialKey)">删除</div>
            <el-checkbox-group style="margin-left: 10px;" v-model="checkedCities" @change="handleCheckedCitiesChange">
              <el-checkbox :label="item.materialKey"><br /></el-checkbox>
            </el-checkbox-group>
          </div>

        </li>
      </ul>

      <div style="margin-top: 50px;height: 50px;width: 100%;">
        <el-pagination @current-change="handleCurrentChange" :current-page="PageIndex" :page-size="10" layout="total, prev, pager, next" :total="Counts">
        </el-pagination>
      </div>

    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      MaterialType:'',
      checkedCities: [],
      data: [],
      Counts:1,
      fItemKey: "",
      MaterialName: "",//标题名称
      PageIndex: 1,
      PageSize: 10,
      ItemKey: "",//栏目ID
      list: [],
      delfunsdata: [],//多选删除数据
    }
  },
  mounted() {
    this.loading();
    this.$Http_Post('management/getColumnManagementByNode', { PItemKey: '0', pageIndex: "1", pageSize: "111110", Type: 1,RoleID:sessionStorage.getItem('RoleID')}).then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.data = res.Data;
      } else {
        this.Global.request_failure(res.Message);
      }
    })
  },
  methods: {
    resetfun(){
      this.MaterialName = '';
      this.PageIndex = 1;
      this.ItemKey = '';
      this.MaterialType = '';
      this.loading();
    },
    check_tree(dt, obj, node) {
      if (dt.fuzi && dt.children.length > 0) {
        dt.children = [{ label: this.$t('original.languages22') }]
        this.$Http_Post('management/getColumnManagementByNode', { PItemKey:dt.value,pageIndex: "1",pageSize:"111110", Type: 1,RoleID:sessionStorage.getItem('RoleID')}).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            if (res.Data) {
              dt.children = res.Data;
            }
          }
        })
      }
      this.PageIndex = 1;
      this.PageSize = 10;
      this.ItemKey = dt.value;
      this.loading();
    },

    delfuns() {
      this.$Http_Post('management/materialDelS', { MaterialKeys: this.delfunsdata }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.Global.request_successful(res.Message);
          this.loading();
          this.delfunsdata = [];
        } else {
          this.Global.request_failure(res.Message);
        }
      })
    },
    handleCheckedCitiesChange(value) {//多选删除
      this.delfunsdata = value;
    },
    handleCurrentChange(val) {
      this.PageIndex = val;
      this.loading();
    },
    delfun(val) {
      this.$Http_Post('management/materialDel', { MaterialKey: val}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.Global.request_successful(res.Message);
          this.loading();
        } else {
          this.Global.request_failure(res.Message);
        }
      })
    },
    gourl(val, materialKey) {
      // 1 = 文章 2 = 图片 3 = 音乐 4 = 视频 5 = 游戏 51 word文档 52 pdf文档 53 excel文档
      if (val == 1) {

      } else if (val == 2) {
        this.$router.push({
          path: '/propagate/Propagate_look',
          query: { materialKey: materialKey, Type: 3 },
        })
      } else if (val == 3) {
        this.$router.push({
          path: '/propagate/Propagate_look',
          query: { materialKey: materialKey, Type: 1 },
        })
      }else if (val == 4) {
        this.$router.push({
          path: '/propagate/Propagate_look',
          query: { materialKey: materialKey, Type: 2 },
        })
      }else if (val == 5) {

      }else if (val == 6) {

      }
    },
    loading() {
      this.$Http_Post('management/getMaterialList', { MaterialName: this.MaterialName, PageIndex: this.PageIndex, PageSize: this.PageSize, ItemKey: this.ItemKey,MaterialType:this.MaterialType}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.list = res.Data;
          this.Counts = res.Counts;
        } else {
          this.Global.request_failure(res.Message);
        }
      })
    },
    onSubmit() {
      this.PageIndex = 1;
      this.loading();
    },

    // Selected_to_shut_dow(dt) {
    //   this.ItemKey = dt[dt.length - 1];
    //   this.$refs.wcascader.dropDownVisible = false;
    // },
    // GetNodeByDeptID(ID, NodeList) {
    //   let obj = null;
    //   for (let i = 0; i < NodeList.length; i++) {
    //     if (NodeList[i].value == ID) {
    //       obj = NodeList[i]
    //       break
    //     } else if (
    //       NodeList[i].fuzi && NodeList[i].children.length > 0 && NodeList[i].children[0].value != '-1'
    //     ) {
    //       obj = this.GetNodeByDeptID(ID, NodeList[i].children)
    //       if (obj != null) break
    //     }
    //   }
    //   return obj
    // },
    // bumen(dt) {
    //   let obj = this.data[0]
    //   for (let i = 0; i < this.data.length; i++) {
    //     if (this.data[i].value == dt[dt.length - 1]) {
    //       obj = this.data[i];
    //     } else if (this.data[i].fuzi && this.data[i].children.length > 0 && this.data[i].children[0].value != '-1') {
    //       obj = this.GetNodeByDeptID(dt[dt.length - 1], this.data[i].children);
    //     }
    //   }
    //   if (obj.fuzi && obj.children.length > 0 && obj.children[0].value == '-1') {
    //     obj.children = [{ label: this.$t('original.languages22') }]
    //     this.$Http_Post('/management/getColumnManagementByNode', { PItemKey: dt[dt.length - 1], pageIndex: "1", pageSize: "111110", Type: 1 }).then((res) => {
    //       if (res.Code == 200 || res.Code == 0 && res.Data) {
    //         obj.children = res.Data;
    //       }
    //     })
    //   }
    // },
  },
}
</script>
<style>
.Material_management{width: 100%;height: 100%;background-color: #fff;}
.Material_management .el-tabs__nav-scroll{margin-left: 10px;padding-top: 10px;}
.Material_management .tp li{width: 300px;height: 200px;float: left;margin-left: 20px;margin-top: 20px;position: relative;}
.Material_management .tp li:hover .tp_top,.tp_bou{opacity: 1;}
.Material_management .tp li:hover .tp_bou{opacity: 1;}
.Material_management .tp li .tp_top{position: absolute;top: 0px;left: 0px;height: 30px;width: 100%;background-color: rgba(0, 0, 0, 0.298039215686275);color: #fff;text-align: center;line-height: 30px;transition: all 1s;cursor:pointer;}
.Material_management .tp li .tp_bou{position: absolute;bottom: 0px;left: 0px;height: 30px;width: 100%;background-color: rgba(0, 0, 0, 0.298039215686275);color: #fff;text-align: center;line-height: 30px;opacity: 0; transition: 1s;cursor:pointer;}
.Material_management .tp li img{width: 100%;height: 170px;}
</style>
